import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ChevronLeft, ChevronRight, Eye } from 'lucide-react';
const PREVIEW_IMAGES = [{
  url: 'https://cdn.magicpatterns.com/uploads/wbVtNhQR1Qd1YLavUk38XX/hoja_1_sic.png',
  label: 'Clase 1'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/dyUoxT5QpVmrBgr4N9MKCT/Hoja_2_sic.png',
  label: 'Clase 3'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/8muQRoFcvRBEBkLiPdNs46/Hoja_3_sic.png',
  label: 'Evaluación'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/epqQtWKyggXUNfGT47orBP/Hoja_4_sic.png',
  label: 'Clase 8'
}];
export function PreviewCarousel() {
  const [current, setCurrent] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setIsVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const next = useCallback(() => {
    setCurrent(p => (p + 1) % PREVIEW_IMAGES.length);
  }, []);
  const prev = useCallback(() => {
    setCurrent(p => (p - 1 + PREVIEW_IMAGES.length) % PREVIEW_IMAGES.length);
  }, []);
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.touches[0].clientX);
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? next() : prev();
    }
    setTouchStart(null);
  };
  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);
  return <section ref={sectionRef} className="py-12 bg-gradient-to-b from-slate-50 to-white" data-id="element-140">
      <div className="max-w-4xl mx-auto px-4" data-id="element-141">
        {/* Header */}
        <div className={`text-center mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`} data-id="element-142">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-600 font-bold px-5 py-2 rounded-full text-sm mb-4 border border-blue-100" data-id="element-143">
            <Eye className="w-4 h-4" data-id="element-144" />
            MIRÁ POR DENTRO
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-2" data-id="element-145">
            Páginas reales del <span className="text-orange-500" data-id="element-146">material</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-147">
            Proyectos paso a paso, clases listas y actividades prácticas
          </p>
        </div>

        {/* Carousel */}
        <div className={`relative transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-148">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl border-2 border-slate-200 bg-white" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-149">
            <div className="flex transition-transform duration-500 ease-out" style={{
            transform: `translateX(-${current * 100}%)`
          }} data-id="element-150">
              {PREVIEW_IMAGES.map((img, i) => <div key={i} className="min-w-full" data-id="element-151">
                  <img src={img.url} alt={img.label} className="w-full h-auto" draggable={false} data-id="element-152" />
                </div>)}
            </div>

            <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2.5 rounded-full shadow-lg transition-all z-10 border border-slate-200" aria-label="Anterior" data-id="element-153">
              <ChevronLeft className="w-5 h-5 text-slate-700" data-id="element-154" />
            </button>
            <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2.5 rounded-full shadow-lg transition-all z-10 border border-slate-200" aria-label="Siguiente" data-id="element-155">
              <ChevronRight className="w-5 h-5 text-slate-700" data-id="element-156" />
            </button>

            <div className="absolute top-4 right-4 bg-slate-900/70 text-white text-xs font-bold px-3 py-1.5 rounded-full z-10" data-id="element-157">
              {current + 1} / {PREVIEW_IMAGES.length}
            </div>
          </div>

          <div className="flex justify-center gap-3 mt-5" data-id="element-158">
            {PREVIEW_IMAGES.map((img, i) => <button key={i} onClick={() => setCurrent(i)} className={`rounded-xl overflow-hidden border-2 transition-all duration-300 w-20 h-14 flex-shrink-0 ${current === i ? 'border-blue-500 shadow-md scale-105 opacity-100' : 'border-slate-200 opacity-50 hover:opacity-80'}`} aria-label={`Ver ${img.label}`} data-id="element-159">
                <img src={img.url} alt={img.label} className="w-full h-full object-cover object-top" draggable={false} data-id="element-160" />
              </button>)}
          </div>

          <p className="text-center text-sm text-slate-400 mt-3 md:hidden" data-id="element-161">
            ← Deslizá para ver más →
          </p>
        </div>
      </div>
    </section>;
}